<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import EmptyLayout from "@/layouts/EmptyLayout";
import MainLayout from "@/layouts/MainLayout";
import { mapMutations } from "vuex"

export default {
  components: {
    EmptyLayout,
    MainLayout,
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || "empty") + "-layout";
    },
  },
  mounted() {
    const token = localStorage.getItem("token")
    if(token) this.getUser()
  },
  methods: {
    ...mapMutations(['SET_USER']),
    async getUser() {
      try {
        const { data } = await this.$axios.get('users/me')
        this.SET_USER(data.data ?? { })
      } catch (e) {
        console.error(e)
        throw e
      }
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap');

body, html {
  margin: 0 !important;
  padding: 0 !important;
}

body {
  overflow-x: hidden;
  min-height: 100vh;
  font-family: 'IBM Plex Sans', sans-serif;
  background-color: #E6EAF2;
}
</style>
